import { render, staticRenderFns } from "./ExternalResetPassword.vue?vue&type=template&id=553d426a&scoped=true&"
import script from "./ExternalResetPassword.vue?vue&type=script&lang=js&"
export * from "./ExternalResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553d426a",
  null
  
)

export default component.exports